import {getMessages} from 'app/store/constants';

export const BOARD_MOVE_TO_SECTION_TITLE = getMessages().getText('board_settings.move_to.title');
